import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0.601563 6.6H17.4016M2.40156 11.4H9.60156M12.0016 11.4H15.6016M0.601563 4.2L0.601562 13.8C0.601562 14.4627 1.13882 15 1.80156 15L16.2016 15C16.8643 15 17.4016 14.4627 17.4016 13.8V4.2C17.4016 3.53726 16.8643 3 16.2016 3L1.80156 3C1.13882 3 0.601563 3.53726 0.601563 4.2Z",
  stroke: "currentColor"
}, null, -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CreditCardIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "credit-card",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})